import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Reusable "I agree to the Terms and Conditions" checkbox.
 *
 * @param {boolean} checked    - whether the box is ticked
 * @param {(v:boolean)=>void} onChange - called with the new checked value
 * @param {boolean} [error]    - when true, highlights the control in red
 * @param {string}  [className]
 */
const TermsAgreementCheckbox = ({ checked, onChange, error, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <label className="flex items-start gap-2 cursor-pointer text-xs leading-relaxed text-gray-500">
        <input
          type="checkbox"
          checked={!!checked}
          onChange={(e) => onChange?.(e.target.checked)}
          className={`mt-0.5 h-3.5 w-3.5 shrink-0 rounded border-gray-300 text-yellow-500 focus:ring-yellow-500 cursor-pointer ${
            error ? 'border-red-500 ring-1 ring-red-500' : ''
          }`}
        />
        <span>
          {t('common.terms_agree_text')}{' '}
          <Link
            to="/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-yellow-600 hover:text-yellow-700 underline"
            onClick={(e) => e.stopPropagation()}
          >
            {t('common.terms_and_conditions')}
          </Link>{' '}
          {t('common.terms_agree_suffix')}
        </span>
      </label>
      {error && (
        <p className="text-red-500 text-xs mt-1">
          {t('common.terms_agree_required')}
        </p>
      )}
    </div>
  );
};

export default TermsAgreementCheckbox;
